// @flow

import Server from './js/server/';
import util from './js/util';

import type { ServerMethodOptions, ServerMethod } from './js/lib/method';

const server = new Server();

server.util = util;

/**
 * server
 * @deprecated use `server2` instead
 */
module.exports = server;

type ServerResponse = Response;
export type { ServerMethodOptions, ServerMethod, ServerResponse };

require('debug-globals').extend({ server });

